import {
  AffiliationRequest,
  AffiliationRequestToCreate,
  AffiliationRequestToUpdate,
} from '@interfaces/affiliationRequest';
import { Product } from '@interfaces/product';
import { fetcher } from '@utils/fetcher';

const getApiUrl = (productId: Product['id']) =>
  `/api/products/${productId}/affiliationRequest`;

export const findExternalAffiliationRequests = async (
  productIds: Product['id'][],
): Promise<AffiliationRequest[]> =>
  fetcher(
    `/api/affiliationRequest/external?botConfigIds=${JSON.stringify(
      productIds,
    )}`,
    { method: 'GET' },
  );

export const findPersonalAffiliationRequests = async (): Promise<
  AffiliationRequest[]
> => fetcher('/api/affiliationRequest/personal', { method: 'GET' });

export const userHasNonCompletedRequest = async (
  productId: AffiliationRequest['botConfigId'],
) => {
  const nonCompletedRequests = (await fetcher(
    `/api/affiliationRequest?botConfigIds=[]`,
    { method: 'GET' },
  )) satisfies AffiliationRequest[];

  return nonCompletedRequests.some((ncr) => ncr.botConfigId === productId);
};

export const createAffiliationRequest = async (
  productId: Product['id'],
  dto: AffiliationRequestToCreate,
): Promise<AffiliationRequest> =>
  fetcher(`${getApiUrl(productId)}/create`, {
    method: 'POST',
    body: dto,
  });

export const findAffiliationRequest = async (
  productId: Product['id'],
  id: AffiliationRequest['id'],
): Promise<AffiliationRequest> =>
  fetcher(`${getApiUrl(productId)}/${id}`, { method: 'GET' });

export const updateAffiliationRequest = async (
  productId: Product['id'],
  id: AffiliationRequest['id'],
  dto: AffiliationRequestToUpdate,
): Promise<AffiliationRequest> =>
  fetcher(`${getApiUrl(productId)}/${id}`, {
    method: 'PATCH',
    body: dto,
  });
